import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "snippet",
    "data-title": "dot-flashing"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "stage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "dot-flashing" })
    ])
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]


import { restaurant } from '@/global/state/GlobalState';


export default /*#__PURE__*/_defineComponent({
  __name: 'CentralLoader',
  props: { zIndex: { type: Number, required: true }},
  setup(__props) {

_useCssVars(_ctx => ({
  "7d905198": (_unref(restaurant).restaurant_design_custom?.primary_color)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "fixed top-0 left-0 w-full bottom-0 h-full bg-black bg-opacity-60",
      style: _normalizeStyle({zIndex:(__props.zIndex ?? 2) - 1})
    }, null, 4),
    _createElementVNode("div", {
      style: _normalizeStyle({ zIndex: __props.zIndex}),
      class: "fixed left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2"
    }, _hoisted_2, 4)
  ], 64))
}
}

})